module.exports = __webpack_public_path__ + "img/rapa-nui.616af113.svg";